<script context="module">
  import { BACKDROPS, RANKS } from '../utils'

  export { BACKDROPS, RANKS }
</script>

<script>
  import { getClass } from '../utils'

  export let href
  export let backdropColor = BACKDROPS.LIGHT
  export let rank = RANKS.THEME_PRIMARY
  export let isSpecial = false

  $: className = getClass({ backdropColor, rank, isSpecial, className: $$props.class || '' })
</script>

<a {...$$restProps} {href} class={className} on:click>
  <slot />
</a>
